document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initMarquee();
  initAcordeon();
  initContador();
  initGaleriaProducto();
  initVariantes();
  initCarrusel();
  initHeroSlideshow();
  initZoomProducto();
  initGuiaTallas();
  initFlotante();
  initUbicaciones();
  initSelectoresVisuales();
  initCantidadProducto();
  initFavoritos();
  initCompartir();
  initStickyProducto();
  initEntregaProducto();
  initVistos();
  initSearchWildcard();
});

// Shopify's predictive search resolves partial words ("pan" -> "Pantalones"),
// while the regular results page may require an explicit wildcard. Keeping both
// paths aligned prevents a suggestion from turning into an empty result page.
function initSearchWildcard() {
  document.querySelectorAll('form[role="search"]').forEach(function (form) {
    if (form.dataset.zsWildcardSearch === 'true') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;
    form.dataset.zsWildcardSearch = 'true';
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var term = input.value.trim();
      if (!term || /[*"():]/.test(term)) return;
      input.value = term + '*';
    });
  });
}

function initVistos() {
  var key = 'zs-vistos';
  var wrap = document.querySelector('[data-zs-vistos]');
  var current = wrap ? (wrap.getAttribute('data-zs-vistos-actual') || '') : '';

  // 1) Guardar el producto actual (si estamos en una ficha)
  if (current) {
    var lista = [];
    try { lista = JSON.parse(window.localStorage.getItem(key) || '[]'); } catch (e) { lista = []; }
    lista = lista.filter(function (h) { return h && h !== current; });
    lista.unshift(current);
    try { window.localStorage.setItem(key, JSON.stringify(lista.slice(0, 12))); } catch (e) {}
  }

  // 2) Mostrar los vistos (excepto el actual) si hay sección para ello
  if (!wrap) return;
  var contenedor = wrap.querySelector('[data-zs-vistos-lista]');
  if (!contenedor) return;
  var handles = [];
  try { handles = JSON.parse(window.localStorage.getItem(key) || '[]'); } catch (e) { handles = []; }
  var max = parseInt(wrap.dataset.zsVistosCantidad || '8', 10) || 8;
  handles = handles.filter(function (h) { return h && h !== current; }).slice(0, max);
  if (!handles.length) return;

  // Mostrar esqueletos de carga mientras se piden las tarjetas (feel premium, sin salto de layout)
  var skel = '';
  for (var i = 0; i < handles.length; i++) {
    skel += '<div class="zs-skel"><div class="zs-skel__img"></div><div class="zs-skel__line"></div><div class="zs-skel__line zs-skel__line--corto"></div></div>';
  }
  contenedor.innerHTML = skel;
  wrap.hidden = false;

  var sectionId = wrap.getAttribute('data-zs-vistos-section') || 'zs-vistos-item';
  Promise.all(handles.map(function (h) {
    return fetch('/products/' + encodeURIComponent(h) + '?section_id=' + sectionId)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  })).then(function (parts) {
    var html = parts.filter(function (p) { return p && p.trim(); }).join('');
    if (!html.trim()) { wrap.hidden = true; return; }
    contenedor.innerHTML = html;
  });
}

function initUbicaciones() {
  document.querySelectorAll('[data-zs-ubic]').forEach(function (w) {
    var btn = w.querySelector('[data-zs-ubic-btn]');
    var panel = w.querySelector('[data-zs-ubic-panel]');
    if (!btn || !panel) return;
    function abrir() { panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
    function cerrar() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (panel.hidden) abrir(); else cerrar();
    });
    document.addEventListener('click', function (e) { if (!w.contains(e.target)) cerrar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
  });
}

function initZoomProducto() {
  var lightbox = document.querySelector('[data-zs-lightbox]');
  if (!lightbox) return;
  var lbImg = lightbox.querySelector('[data-zs-lightbox-img]');
  var lupas = document.querySelectorAll('[data-zs-zoom-abrir]');
  var cerrar = lightbox.querySelector('[data-zs-zoom-cerrar]');

  var lbOpener = null;
  function abrir(e) {
    var disparador = e && e.currentTarget ? e.currentTarget : null;
    if (!disparador || !disparador.dataset.zsZoomSrc) return;
    lbOpener = disparador;
    lbImg.src = disparador.dataset.zsZoomSrc;
    lbImg.alt = disparador.dataset.zsZoomAlt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    if (typeof trapFocus === 'function') { trapFocus(lightbox); } else if (cerrar) { cerrar.focus(); }
  }
  function cerrarLb() {
    lightbox.hidden = true;
    document.body.style.overflow = '';
    if (typeof removeTrapFocus === 'function') { removeTrapFocus(lbOpener); } else if (lbOpener) { lbOpener.focus(); }
  }
  lupas.forEach(function (lupa) { lupa.addEventListener('click', abrir); });
  if (cerrar) cerrar.addEventListener('click', cerrarLb);
  lightbox.addEventListener('click', function (e) { if (e.target === lightbox) cerrarLb(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lightbox.hidden) cerrarLb(); });
}

function initGuiaTallas() {
  var modal = document.querySelector('[data-zs-guia]');
  if (!modal) return;
  var abrir = document.querySelectorAll('[data-zs-guia-abrir]');
  var cerrar = modal.querySelectorAll('[data-zs-guia-cerrar]');
  var opener = null;
  var caja = modal.querySelector('.zs-modal__caja') || modal;
  function abrirModal(e) {
    opener = e && e.currentTarget ? e.currentTarget : null;
    modal.hidden = false; document.body.style.overflow = 'hidden';
    if (typeof trapFocus === 'function') { trapFocus(caja); } else { var c = modal.querySelector('[data-zs-guia-cerrar]'); if (c) c.focus(); }
  }
  function cerrarModal() {
    modal.hidden = true; document.body.style.overflow = '';
    if (typeof removeTrapFocus === 'function') { removeTrapFocus(opener); } else if (opener) { opener.focus(); }
  }
  abrir.forEach(function (b) { b.addEventListener('click', abrirModal); });
  cerrar.forEach(function (b) { b.addEventListener('click', cerrarModal); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) cerrarModal(); });
}

function initFlotante() {
  var arriba = document.querySelector('[data-zs-arriba]');
  if (!arriba) return;
  function toggle() {
    if (window.scrollY > 500) arriba.classList.add('zs-visible');
    else arriba.classList.remove('zs-visible');
  }
  window.addEventListener('scroll', toggle, { passive: true });
  toggle();
  arriba.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

function initHeroSlideshow() {
  document.querySelectorAll('[data-zs-hero-slides]').forEach(function (wrap) {
    var slides = wrap.querySelectorAll('.zs-hero-slide');
    if (slides.length < 2) return;
    if (wrap.dataset.autoplay === 'false') return;
    var velocidad = (parseFloat(wrap.dataset.velocidad || '4')) * 1000;
    var index = 0;
    window.setInterval(function () {
      slides[index].classList.remove('zs-activa');
      index = (index + 1) % slides.length;
      slides[index].classList.add('zs-activa');
    }, velocidad);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.zs-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('zs-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('zs-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquee() {
  document.querySelectorAll('[data-zs-marquee]').forEach(function (wrap) {
    var track = wrap.querySelector('.zs-marquee__track');
    if (!track) return;
    var speed = parseFloat(wrap.dataset.speed || '40');
    track.style.animationDuration = speed + 's';
  });
}

function initAcordeon() {
  document.querySelectorAll('.zs-acc-item').forEach(function (item) {
    // Las preguntas frecuentes usan <details>, que ya ofrece interacción y
    // accesibilidad nativas. Este controlador queda solo para acordeones legacy.
    if (item.tagName === 'DETAILS') return;
    var btn = item.querySelector('.zs-acc-btn');
    var panel = item.querySelector('.zs-acc-panel');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('zs-open');
      item.closest('[data-zs-faq]').querySelectorAll('.zs-acc-item').forEach(function (other) {
        other.classList.remove('zs-open');
        other.querySelector('.zs-acc-panel').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('zs-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

function initContador() {
  var els = document.querySelectorAll('[data-zs-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var target = parseFloat(el.dataset.zsContador || '0');
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased).toLocaleString('es-ES');
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('es-ES');
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-zs-galeria]');
  if (!galeria) return;
  var minis = galeria.querySelectorAll('[data-zs-galeria-mini]');
  var slides = galeria.querySelectorAll('[data-zs-media-slide]');
  var prev = galeria.querySelector('[data-zs-media-prev]');
  var next = galeria.querySelector('[data-zs-media-next]');
  var viewport = galeria.querySelector('[data-zs-media-viewport]');
  if (!slides.length) return;
  var actual = 0;

  // Las diapositivas inactivas están ocultas y sus imágenes son "lazy": el
  // navegador no las descarga nunca hasta que se muestran, así que al cambiar
  // de color la foto quedaba en blanco unos instantes. Una vez cargada la
  // página (sin competir con la imagen principal ni con el LCP) se pasan a
  // carga normal para que el cambio de variante sea instantáneo.
  function precargarMedia() {
    slides.forEach(function (slide, i) {
      if (i === actual) return;
      slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
        if (!img.complete && img.decode) img.decode().catch(function () {});
      });
    });
  }

  function programarPrecarga() {
    if (window.requestIdleCallback) window.requestIdleCallback(precargarMedia, { timeout: 3000 });
    else window.setTimeout(precargarMedia, 1200);
  }

  if (document.readyState === 'complete') programarPrecarga();
  else window.addEventListener('load', programarPrecarga, { once: true });

  function pausarMedia(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
    slide.querySelectorAll('iframe').forEach(function (frame) {
      frame.contentWindow && frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
  }

  function mostrar(index, enfocarMini) {
    var seguro = (index + slides.length) % slides.length;
    slides.forEach(function (slide, i) {
      if (i !== seguro) pausarMedia(slide);
      slide.hidden = i !== seguro;
      slide.classList.toggle('zs-activa', i === seguro);
    });
    minis.forEach(function (mini, i) {
      var activa = i === seguro;
      mini.classList.toggle('zs-activa', activa);
      mini.setAttribute('aria-selected', String(activa));
      mini.tabIndex = activa ? 0 : -1;
      if (activa) mini.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    actual = seguro;
    if (enfocarMini && minis[seguro]) minis[seguro].focus();
  }

  minis.forEach(function (mini, index) {
    mini.addEventListener('click', function () { mostrar(index, false); });
    mini.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      mostrar(index + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
  });
  if (prev) prev.addEventListener('click', function () { mostrar(actual - 1, false); });
  if (next) next.addEventListener('click', function () { mostrar(actual + 1, false); });

  var touchStart = 0;
  if (viewport) {
    viewport.addEventListener('touchstart', function (event) { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    viewport.addEventListener('touchend', function (event) {
      var distancia = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distancia) < 45) return;
      mostrar(actual + (distancia < 0 ? 1 : -1), false);
    }, { passive: true });
  }

  galeria.addEventListener('zs:media:select', function (event) {
    var mediaId = String(event.detail && event.detail.mediaId || '');
    minis.forEach(function (mini, index) {
      if (String(mini.dataset.zsMediaId) === mediaId) mostrar(index, false);
    });
  });
}

function initCarrusel() {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-zs-carrusel]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-zs-carrusel-track]');
    var section = wrap.closest('.zs-section') || wrap.parentElement;
    var prevBtn = section ? section.querySelector('[data-zs-carrusel-prev]') : null;
    var nextBtn = section ? section.querySelector('[data-zs-carrusel-next]') : null;
    if (!track) return;

    function slideAmount() {
      var slide = track.querySelector('.zs-carrusel-slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap || '20');
      return slide.getBoundingClientRect().width + gap;
    }

    function atStart() { return track.scrollLeft <= 2; }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = atStart();
      if (nextBtn) nextBtn.disabled = atEnd() && track.scrollWidth > track.clientWidth ? false : nextBtn.disabled;
      if (nextBtn) nextBtn.disabled = atEnd();
    }

    function goNext() {
      if (atEnd()) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: slideAmount(), behavior: 'smooth' });
      }
    }

    function goPrev() {
      track.scrollBy({ left: -slideAmount(), behavior: 'smooth' });
    }

    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateButtons);
    }, { passive: true });
    updateButtons();

    var autoplay = wrap.dataset.autoplay === 'true' && !reduceMotion;
    if (!autoplay) return;
    var velocidad = (parseFloat(wrap.dataset.velocidad || '4')) * 1000;
    var timer = null;

    function start() {
      stop();
      timer = window.setInterval(goNext, velocidad);
    }
    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    if (track.scrollWidth > track.clientWidth + 4) {
      start();
      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);
      wrap.addEventListener('focusin', stop);
      wrap.addEventListener('focusout', start);
    }
  });
}

function initVariantes() {
  var form = document.querySelector('[data-zs-form-producto]');
  if (!form) return;
  var dataEl = document.querySelector('[data-zs-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-zs-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-zs-precio]');
  var precioComparadoEl = document.querySelector('[data-zs-precio-comparado]');
  var descuentoEl = document.querySelector('[data-zs-descuento]');
  var skuEl = document.querySelector('[data-zs-sku]');
  var stockEl = document.querySelector('[data-zs-stock]');
  var botonEl = form.querySelector('[data-zs-boton-comprar]');
  var textoDisponible = form.dataset.textoDisponible || 'Añadir al carrito';
  var textoAgotado = form.dataset.textoAgotado || 'Agotado';

  function moneyFmt(cents) {
    var moneda = (precioEl && precioEl.dataset.zsCurrency) || 'ARS';
    try {
      return (cents / 100).toLocaleString('es-AR', { style: 'currency', currency: moneda, minimumFractionDigits: 2 });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  var galeria = document.querySelector('[data-zs-galeria]');
  var minis = document.querySelectorAll('[data-zs-galeria-mini]');
  var stickyPrecio = document.querySelector('[data-zs-sticky-precio]');
  var stickyBtn = document.querySelector('[data-zs-sticky-btn]');

  function setTextoBoton(el, texto) {
    if (!el) return;
    var span = el.querySelector('span');
    if (span) span.textContent = texto; else el.textContent = texto;
  }

  function cambiarImagenVariante(mediaId) {
    if (!mediaId || !galeria) return;
    galeria.dispatchEvent(new CustomEvent('zs:media:select', { detail: { mediaId: mediaId } }));
  }

  function actualizar() {
    if (!selects.length) return;
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });

    // Combinación inexistente: bloquear la compra (no dejar añadir una variante incorrecta)
    if (!match) {
      if (idInput) idInput.value = '';
      if (botonEl) { botonEl.disabled = true; setTextoBoton(botonEl, 'Combinación no disponible'); }
      if (stickyBtn) { stickyBtn.disabled = true; setTextoBoton(stickyBtn, 'No disponible'); }
      return;
    }

    if (idInput) idInput.value = match.id;
    if (precioEl) precioEl.textContent = moneyFmt(match.price);
    if (stickyPrecio) stickyPrecio.textContent = moneyFmt(match.price);
    if (precioComparadoEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioComparadoEl.textContent = moneyFmt(match.compare_at_price);
        precioComparadoEl.style.display = '';
      } else {
        precioComparadoEl.style.display = 'none';
      }
    }
    if (descuentoEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        descuentoEl.textContent = '-' + Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price) + '%';
        descuentoEl.hidden = false;
      } else {
        descuentoEl.hidden = true;
      }
    }
    if (skuEl) {
      skuEl.textContent = match.sku ? 'SKU: ' + match.sku : '';
      skuEl.hidden = !match.sku;
    }
    if (stockEl) {
      var umbral = parseInt(stockEl.dataset.umbral || '5', 10);
      var controlado = !!match.inventory_management && match.inventory_policy === 'deny';
      if (!match.available) stockEl.textContent = 'Agotado';
      else if (controlado && match.inventory_quantity > 0 && match.inventory_quantity <= umbral) stockEl.textContent = match.inventory_quantity === 1 ? 'Queda 1 unidad' : 'Quedan ' + match.inventory_quantity + ' unidades';
      else stockEl.textContent = 'Disponible';
    }
    if (botonEl) {
      botonEl.disabled = !match.available;
      setTextoBoton(botonEl, match.available ? textoDisponible : textoAgotado);
    }
    if (stickyBtn) {
      stickyBtn.disabled = !match.available;
      setTextoBoton(stickyBtn, match.available ? textoDisponible : textoAgotado);
    }
    cambiarImagenVariante(match.media_id);
  }

  // La falta de stock se señalaba solo con un estilo: se añade al nombre
  // accesible para que también se anuncie y se vea al pasar el cursor.
  function marcarDisponibilidad(btn, disponible) {
    btn.classList.toggle('zs-no-disponible', !disponible);
    var base = btn.dataset.zsValor || btn.textContent.trim();
    var etiqueta = disponible ? base : base + ' — sin stock';
    btn.setAttribute('aria-label', etiqueta);
    btn.title = etiqueta;
  }

  // Marca visualmente los valores agotados.
  // Colores: se muestran siempre con su color pleno y solo se apagan si el color
  // no queda disponible en ningun talle (al hacer clic se salta al talle correcto).
  // Talles: se marcan segun el color que este elegido en ese momento.
  function marcarNoDisponibles() {
    if (!selects.length) return;
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    document.querySelectorAll('.zs-prod-opcion').forEach(function (wrap, idx) {
      wrap.querySelectorAll('[data-zs-swatch]').forEach(function (btn) {
        var hayAlguna = variantes.some(function (vr) {
          return vr.options[idx] === btn.dataset.zsValor && vr.available;
        });
        marcarDisponibilidad(btn, hayAlguna);
      });
      wrap.querySelectorAll('[data-zs-pill]').forEach(function (btn) {
        var prueba = seleccion.slice();
        prueba[idx] = btn.dataset.zsValor;
        var v = variantes.find(function (vr) {
          return vr.options.every(function (opt, i) { return opt === prueba[i]; });
        });
        marcarDisponibilidad(btn, Boolean(v && v.available));
      });
    });
  }

  selects.forEach(function (s) { s.addEventListener('change', function () { actualizar(); marcarNoDisponibles(); }); });
  actualizar();
  marcarNoDisponibles();
}

function initStickyProducto() {
  var sticky = document.querySelector('[data-zs-sticky]');
  if (!sticky) return;
  var formId = sticky.dataset.zsFormTarget;
  var form = formId ? document.getElementById(formId) : document.querySelector('[data-zs-form-producto]');
  var botonReal = document.querySelector('[data-zs-boton-comprar]');
  var stickyBtn = sticky.querySelector('[data-zs-sticky-btn]');
  if (stickyBtn && botonReal) {
    stickyBtn.addEventListener('click', function () {
      if (botonReal.disabled) return;
      botonReal.click();
    });
  }
  if (!botonReal) return;
  // Reserva abajo el alto real de la barra para que los botones flotantes
  // (WhatsApp, volver arriba) suban lo justo y nunca la tapen. El CSS ya deja
  // un valor de respaldo por si el JS no llega a ejecutarse.
  function ajustarEspacioInferior(visible) {
    if (!visible) {
      document.body.style.removeProperty('--zs-bottom-inset');
      return;
    }
    var alto = Math.round(sticky.getBoundingClientRect().height);
    if (alto > 0) document.body.style.setProperty('--zs-bottom-inset', alto + 14 + 'px');
  }

  function actualizarSticky() {
    var r = botonReal.getBoundingClientRect();
    // Mostrar la barra cuando el botón principal ya se desplazó por encima del viewport
    var visible = r.bottom < 60;
    sticky.classList.toggle('zs-visible', visible);
    ajustarEspacioInferior(visible);
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { actualizarSticky(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', actualizarSticky, { passive: true });
  actualizarSticky();
}

// El color/talle elegido se marcaba solo con una clase CSS: sin aria-pressed
// un lector de pantalla no podía saber cuál estaba seleccionado.
function marcarSeleccion(btn, activo) {
  btn.classList.toggle('zs-activa', activo);
  btn.setAttribute('aria-pressed', activo ? 'true' : 'false');
}

function initSelectoresVisuales() {
  var dataEl = document.querySelector('[data-zs-variantes-json]');
  var variantes = [];
  if (dataEl) {
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { variantes = []; }
  }
  var todosLosSelects = document.querySelectorAll('[data-zs-opcion]');

  document.querySelectorAll('.zs-prod-opcion').forEach(function (wrap) {
    var select = wrap.querySelector('[data-zs-opcion]');
    if (!select) return;
    var valorEl = wrap.querySelector('[data-zs-opcion-valor]');
    var botones = wrap.querySelectorAll('[data-zs-swatch], [data-zs-pill]');
    if (!botones.length) return;
    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var valor = btn.dataset.zsValor;
        select.value = valor;
        botones.forEach(function (b) { marcarSeleccion(b, false); });
        marcarSeleccion(btn, true);
        if (valorEl) valorEl.textContent = valor;

        // Si la combinación actual no existe como variante, saltar a otra
        // combinación que sí exista y mantenga el valor recién elegido
        // (por ejemplo: elegir un color que no viene en el talle seleccionado).
        if (variantes.length && todosLosSelects.length > 1) {
          var seleccion = Array.prototype.map.call(todosLosSelects, function (s) { return s.value; });
          var existe = variantes.some(function (v) {
            return v.options.every(function (opt, i) { return opt === seleccion[i]; });
          });
          if (!existe) {
            var indiceActual = Array.prototype.indexOf.call(todosLosSelects, select);
            var alternativa = variantes.find(function (v) { return v.options[indiceActual] === valor; });
            if (alternativa) {
              alternativa.options.forEach(function (opcionValor, i) {
                if (i === indiceActual) return;
                todosLosSelects[i].value = opcionValor;
                var otroWrap = todosLosSelects[i].closest('.zs-prod-opcion');
                if (!otroWrap) return;
                var otroValorEl = otroWrap.querySelector('[data-zs-opcion-valor]');
                if (otroValorEl) otroValorEl.textContent = opcionValor;
                otroWrap.querySelectorAll('[data-zs-swatch], [data-zs-pill]').forEach(function (b) {
                  marcarSeleccion(b, b.dataset.zsValor === opcionValor);
                });
              });
            }
          }
        }

        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
}

function initCantidadProducto() {
  document.querySelectorAll('[data-zs-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-zs-cantidad-input]');
    var menos = wrap.querySelector('[data-zs-cantidad-menos]');
    var mas = wrap.querySelector('[data-zs-cantidad-mas]');
    if (!input) return;
    function ajustar(delta) {
      var min = parseInt(input.min, 10) || 1;
      var actual = parseInt(input.value, 10) || min;
      input.value = Math.max(min, actual + delta);
    }
    if (menos) menos.addEventListener('click', function () { ajustar(-1); });
    if (mas) mas.addEventListener('click', function () { ajustar(1); });
    input.addEventListener('change', function () {
      var min = parseInt(input.min, 10) || 1;
      if (!input.value || parseInt(input.value, 10) < min) input.value = min;
    });
  });
}

function initFavoritos() {
  document.querySelectorAll('[data-zs-favorito]').forEach(function (btn) {
    var id = btn.dataset.productoId;
    var texto = btn.querySelector('[data-zs-favorito-texto]');
    if (!id) return;
    function leer() {
      try { return JSON.parse(window.localStorage.getItem('zs-favoritos') || '[]'); }
      catch (e) { return []; }
    }
    function pintar() {
      var activo = leer().indexOf(id) !== -1;
      btn.setAttribute('aria-pressed', activo ? 'true' : 'false');
      if (texto) texto.textContent = activo ? 'En favoritos' : 'Favorito';
    }
    btn.addEventListener('click', function () {
      var lista = leer();
      var idx = lista.indexOf(id);
      if (idx === -1) lista.push(id); else lista.splice(idx, 1);
      window.localStorage.setItem('zs-favoritos', JSON.stringify(lista));
      pintar();
      document.dispatchEvent(new CustomEvent('zs:favorites:changed', { detail: { handles: lista } }));
    });
    pintar();
  });
}

function initEntregaProducto() {
  document.querySelectorAll('[data-zs-entrega]').forEach(function (wrap) {
    var salida = wrap.querySelector('[data-zs-entrega-texto]');
    if (!salida) return;

    var zona = wrap.dataset.zona || 'America/Argentina/Buenos_Aires';
    var preparacion = Math.max(0, parseInt(wrap.dataset.preparacion || '1', 10));
    var minimo = Math.max(0, parseInt(wrap.dataset.transitoMin || '2', 10));
    var maximo = Math.max(minimo, parseInt(wrap.dataset.transitoMax || '4', 10));
    var horaCorte = Math.min(23, Math.max(0, parseInt(wrap.dataset.horaCorte || '15', 10)));
    var feriados = (wrap.dataset.feriados || '').split(',').map(function (valor) { return valor.trim(); }).filter(Boolean);
    var diasHabiles = (wrap.dataset.diasHabiles || '1,2,3,4,5').split(',').map(function (valor) { return parseInt(valor.trim(), 10); }).filter(function (valor) { return valor >= 0 && valor <= 6; });
    if (!diasHabiles.length) diasHabiles = [1, 2, 3, 4, 5];

    var partes = new Intl.DateTimeFormat('en-CA', {
      timeZone: zona,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date()).reduce(function (acc, parte) {
      acc[parte.type] = parte.value;
      return acc;
    }, {});

    var base = new Date(Date.UTC(Number(partes.year), Number(partes.month) - 1, Number(partes.day), 12));
    var antesDelCorte = Number(partes.hour) < horaCorte;
    if (!antesDelCorte) preparacion += 1;

    function clave(fecha) { return fecha.toISOString().slice(0, 10); }
    function habil(fecha) { return diasHabiles.indexOf(fecha.getUTCDay()) !== -1 && feriados.indexOf(clave(fecha)) === -1; }
    function sumarHabiles(fecha, dias) {
      var copia = new Date(fecha.getTime());
      var agregados = 0;
      while (agregados < dias) {
        copia.setUTCDate(copia.getUTCDate() + 1);
        if (habil(copia)) agregados += 1;
      }
      return copia;
    }

    var despacho = sumarHabiles(base, preparacion);
    var desde = sumarHabiles(despacho, minimo);
    var hasta = sumarHabiles(despacho, maximo);

    if (wrap.dataset.zsEntregaModo === 'single') {
      // Encabezado del carrito: una sola fecha (la más próxima estimada), sin la frase larga.
      var formatoCorto = new Intl.DateTimeFormat('es-AR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
      var texto = formatoCorto.format(desde);
      salida.textContent = texto.charAt(0).toUpperCase() + texto.slice(1);
      return;
    }

    var formato = new Intl.DateTimeFormat('es-AR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
    var prefijo = antesDelCorte ? 'Comprando hoy antes de las ' + String(horaCorte).padStart(2, '0') + ':00, ' : 'Comprando ahora, ';
    salida.textContent = prefijo + 'entrega estimada entre el ' + formato.format(desde) + ' y el ' + formato.format(hasta) + '.';
  });
}

function initCompartir() {
  document.querySelectorAll('[data-zs-compartir]').forEach(function (btn) {
    var texto = btn.querySelector('[data-zs-compartir-texto]');
    btn.addEventListener('click', function () {
      var url = btn.dataset.url || window.location.href;
      var titulo = btn.dataset.titulo || document.title;
      if (navigator.share) {
        navigator.share({ title: titulo, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          if (!texto) return;
          var original = texto.textContent;
          texto.textContent = '¡Enlace copiado!';
          window.setTimeout(function () { texto.textContent = original; }, 2000);
        });
      }
    });
  });
}
